import { ValidationMessageEvent, NewsletterSubscriptionEvent } from '@theme/events';
import { getSafeValidationMessage } from '@theme/utilities';

/**
 * Minimal `newsletter_subscription`/`validation_message` tracking for
 * `blocks/email-signup.liquid`'s native `{% form 'customer' %}` — deliberately NOT a full
 * custom-element port (no `novalidate`, no custom validation UI): this only adds tracking, it
 * does not change the form's behavior.
 *
 * Shopify's native (non-AJAX) form does a full-page POST + redirect on submit, which wipes the
 * input — so the entered email is captured to `sessionStorage` right before submit and read back
 * once the reloaded page shows the server-rendered success state, then discarded.
 */

/** @param {HTMLInputElement} input */
function pendingEmailKey(input) {
  return `gtm_newsletter_pending_email:${input.id.replace(/^EmailInput-/, '')}`;
}

document.querySelectorAll('.email-signup__form').forEach((form) => {
  const emailInput = form.querySelector('input[type="email"][name="contact[email]"]');
  if (!(emailInput instanceof HTMLInputElement)) return;

  form.addEventListener('submit', () => {
    sessionStorage.setItem(pendingEmailKey(emailInput), emailInput.value.trim());
  });

  // `invalid` does not bubble, so this must listen on the form itself in the capture phase to
  // catch it from the email input.
  form.addEventListener(
    'invalid',
    (event) => {
      const field = event.target;
      if (!(field instanceof HTMLInputElement) || field.validity.valid) return;

      document.dispatchEvent(new ValidationMessageEvent(getSafeValidationMessage(field), field.name || field.id || ''));
    },
    { capture: true }
  );
});

document.querySelectorAll('[id^="Email-signup__message-error-"]').forEach((errorEl) => {
  const text = (errorEl.textContent || '').replace(/\s+/g, ' ').trim();
  if (!text) return;

  document.dispatchEvent(new ValidationMessageEvent(text, 'contact[email]'));
});

document.querySelectorAll('[id^="Email-signup__message-success-"]').forEach((successEl) => {
  const blockId = successEl.id.replace(/^Email-signup__message-success-/, '');
  const key = `gtm_newsletter_pending_email:${blockId}`;
  const email = sessionStorage.getItem(key);
  sessionStorage.removeItem(key);
  if (!email) return;

  document.dispatchEvent(new NewsletterSubscriptionEvent(blockId, email));
});
